import React from 'react'

import PropTypes from 'prop-types'

import { Container } from './styles'

import Loading from '../Loading'

const Button = ({
  type = 'primary',
  nativeType = 'button',
  size = 'regular',
  full = false,
  children,
  loading,
  disabled,
  ...props
}) => (
  <Container
    type={nativeType}
    buttonType={type}
    size={size}
    disabled={loading || disabled}
    full={full}
    {...props}
  >
    {loading ? <Loading className="loading" size={24} /> : children}
  </Container>
)

Button.propTypes = {
  loading: PropTypes.bool,
  full: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any.isRequired,
  size: PropTypes.oneOf(['large', 'regular', 'mini']),
  type: PropTypes.oneOf(['primary', 'text', 'translucid', 'tab']),
  nativeType: PropTypes.oneOf(['button', 'submit', 'reset'])
}

export default Button
